// Mock data for M.O.Media clone

export const navLinks = [
  { label: 'LLIT-Media.de', href: '#home' },
  { label: 'Unsere Services', href: '#services' },
  { label: 'Über uns', href: '#about' },
  { label: 'Kontakt', href: '#contact' },
];

export const services = [
  {
    id: 'social-media-management',
    icon: 'Rocket',
    title: 'Social Media Management',
    tagline: 'Steigere deine Reichweite und gewinne neue Follower und Neukunden',
    description:
      'Mit unserer 360° Social Media Betreuung für deinen Social-Media Auftritt bieten wir dir alles, was du brauchst, um deine Online-Präsenz zu maximieren. Wir entwickeln maßgeschneiderte Social Media Kommunikations-Konzepte für dein Unternehmen und kümmern uns um die Community-Betreuung, damit du eine aktive und engagierte Followerschaft aufbaust.',
  },
  {
    id: 'videoproduktion',
    icon: 'Video',
    title: 'Videoproduktion',
    tagline: 'Professionelle Videoproduktion für Kampagnen, Veranstaltungen, Imagefilme & private Anlässe',
    description:
      'Mit unserer Videoproduktion erhältst du maßgeschneiderte, projektbezogene Videos, die deine Marke oder deinen persönlichen Moment optimal in Szene setzen. Ob für Kampagnen, Firmenveranstaltungen, Imagefilme oder private Anlässe wie Hochzeiten, Geburtstage und andere wichtige Tage – unsere professionellen Videos sorgen dafür, dass deine Botschaft klar und emotional wirkungsvoll rüberkommt.',
  },
  {
    id: 'fotoproduktion',
    icon: 'Camera',
    title: 'Fotoproduktion',
    tagline: 'Hochwertige Fotoshootings für Business, Produkte, Marken & private Anlässe',
    description:
      'Mit unserer Fotoproduktion setzen wir dich, dein Unternehmen, deine Produkte oder deine besonderen Momente ins beste Licht. Von Business-Portraits und Produkt-Shootings über Content-Serien für Social Media bis hin zu privaten Anlässen wie Hochzeiten, Verlobungen, Geburtstagen und wichtigen Familientagen – wir liefern hochwertige Bilder, die authentisch und emotional wirken.',
  },
];

export const benefits = [
  {
    title: 'Maximale Transparenz',
    text: 'Ehrliche und klare Kommunikation.',
  },
  {
    title: 'Kreative Inhalte, die überzeugen',
    text: 'Einzigartige und innovative Social Media Konzepte, die deine Marke von der Konkurrenz abheben.',
  },
  {
    title: 'Erfolgsorientierte Strategien',
    text: 'Datenbasiertes Social Media Marketing für mehr Reichweite, höhere Interaktionsraten und langfristige Kundenbindung.',
  },
  {
    title: 'Stetig wachsende Accounts',
    text: 'Mehr Reichweite, mehr Engagement und eine aktive Community.',
  },
  {
    title: 'Mehr Zeit für dein Kerngeschäft',
    text: 'Wir übernehmen dein Social Media Marketing, während du dich auf dein Business konzentrierst.',
  },
  {
    title: 'Ein funktionierender Prozess',
    text: 'Strategien, die regelmäßig neue Kunden gewinnen und nachhaltig funktionieren.',
  },
  {
    title: 'Ein erfolgreiches Geschäft',
    text: 'Gezielte Social Media Maßnahmen, die deinen Umsatz und deine Markenbekanntheit steigern.',
  },
];

export const clients = [
  { name: 'M2 Zahnärzte', label: 'M2' },
  { name: 'JustFitteds', label: 'Just Fitteds' },
  { name: 'MCM', label: 'MCM' },
  { name: 'Word of Candy', label: 'Candy' },
  { name: 'Underdocks', label: 'Underdocks' },
  { name: 'Unique Pieces', label: 'Unique Pieces' },
  { name: 'Vivet Restaurant', label: 'VIVET' },
];

export const instagramPosts = [
  {
    id: 1,
    image:
      'https://images.unsplash.com/photo-1611162617213-7d7a39e9b1d7?w=600&q=80',
    caption: 'Behind the scenes bei einem Charity-Event in Bremen.',
    likes: 245,
  },
  {
    id: 2,
    image: '/uploads/llit-camera-setup.jpg',
    caption: 'LLIT-Media Equipment Setup.',
    likes: 412,
  },
  {
    id: 3,
    image:
      'https://images.unsplash.com/photo-1432888622747-4eb9a8efeb07?w=600&q=80',
    caption: 'Hör jetzt unseren neuen Podcast!',
    likes: 189,
  },
  {
    id: 4,
    image: '/uploads/llit-phone-apps.jpg',
    caption: 'Social Media auf einen Blick.',
    likes: 356,
  },
];

export const heroImage =
  'https://images.unsplash.com/flagged/photo-1595514191830-3e96a518989b?w=900&q=85';

export const vorteileImage =
  'https://images.unsplash.com/photo-1552581234-26160f608093?w=900&q=80';

export const aboutImage1 =
  'https://images.unsplash.com/photo-1516387938699-a93567ec168e?w=900&q=80';

export const aboutImage2 =
  'https://images.unsplash.com/photo-1553028826-1e7ae9200212?w=900&q=80';

export const contactInfo = {
  email: 'info.llit.media@gmail.com',
  instagram: 'https://www.instagram.com/llit.media/',
};
